import React, { useState, useRef, useEffect } from "react";
import { Button } from "antd";

const OtpInput = ({
  otp = [],
  setOtp,
  children,
  length = 4,
  onChange = () => {},
  validateOtp,
  login,
  email,
  otpErrorMessage,
  setOtpErrorMessage,
  otpMessageContent,
  autoValidate = true,
  setOtpGlobal = () => {},
}) => {
  // const [otp, setOtp] = useState(Array(length).fill(""));
  const [countdown, setCountdown] = useState(15);
  const [isCountingDown, setIsCountingDown] = useState(true);
  const otpInputRefs = useRef([]);

  const handleInputChange = (value, index) => {
    if (!/^[0-9]$/.test(value)) {
      value = "";
    }
    const newOtp = otp ? [...otp] : [];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value !== "" && index < length - 1) {
      otpInputRefs.current[index + 1].focus();
    }
    onChange(newOtp?.join(""));
  };

  const handleBackspace = (index) => {
    if (index > 0 && otp[index] === "") {
      otpInputRefs.current[index - 1].focus();
      otpInputRefs.current[index - 1].select();
    }
    const newOtp = otp ? [...otp] : [];
    newOtp[index] = "";
    setOtp(newOtp);
    onChange(newOtp?.join(""));
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text/plain").trim().replace(/\s/g, "").slice(0, length);

    const newOtp = Array(length).fill("");
    for (let i = 0; i < pastedData.length; i++) {
      newOtp[i] = pastedData[i];
    }
    otpInputRefs.current[3].focus();

    setOtp(newOtp);
    onChange(newOtp?.join(""));
  };

  const handleEnterKey = (e) => {
    const otpString = otp.join("");
    validateOtp(otpString);
  };

  useEffect(() => {
    const otpString = otp.join("");
    if (autoValidate && otpString?.length === 4) {
      setOtpGlobal(otpString);
      validateOtp(otpString);
    }
  }, [otp, validateOtp, autoValidate]);

  useEffect(() => {
    if (countdown > 0 && isCountingDown) {
      const timer = setTimeout(() => {
        setCountdown((count) => count - 1);
      }, 1000);

      return () => clearTimeout(timer);
    } else {
      setIsCountingDown(false);
    }
  }, [countdown, isCountingDown]);

  useEffect(() => {
    // Set focus on the first input when the component mounts
    if (otpInputRefs?.current[0]) {
      otpInputRefs.current[0].focus();
    }
  }, []);

  const handleResend = () => {
    if (!isCountingDown) {
      login(email);
      setCountdown(15);
      setIsCountingDown(true);
    }
  };

  return (
      <>
          <div className="w-100 d-flex flex-column justify-content-center align-items-center">
              <div>
                  {otp.map((value, index) => {
                      return (
                          <input
                              key={`blink${index}`}
                              id="otpInput"
                              type="text"
                              data-cy="otp-input"
                              className="otp-input"
                              maxLength="1"
                              pattern="[0-9]*"
                              inputMode="numeric"
                              autoFocus
                              style={{
                                  borderBottom: value ? "2px solid #605BFF" : "2px solid rgb(212, 212, 212)",
                              }}
                              value={value}
                              onChange={(e) => {
                                  handleInputChange(e.target.value, index);
                                  setOtpErrorMessage(true);
                                  // if (e.target.value && index < otp.length - 1) {
                                  //   otpInputRefs.current[index + 1].focus(); // Move focus to next input
                                  // }
                              }}
                              onPaste={handlePaste}
                              onKeyUp={(e) => {
                                  if (e.key === "Backspace") {
                                      handleBackspace(index);
                                      if (index > 0) {
                                          otpInputRefs.current[index - 1].focus(); // Move focus to previous input on backspace
                                      }
                                  } else if (e.key === "Enter") {
                                      handleEnterKey(e);
                                  }
                              }}
                              ref={(el) => (otpInputRefs.current[index] = el)}
                          />
                      );
                  })}
              </div>
              <div className="d-flex otp-message-content">
                  <p style={{ color: "red" }} hidden={otpErrorMessage}>
                      {otpMessageContent}
                  </p>
              </div>
          </div>
          {children && children}
          <ReSendOtp isCountingDown={isCountingDown} countdown={countdown} handleResend={handleResend} />
      </>
  );
};

export default OtpInput;

const ReSendOtp = ({ isCountingDown, countdown, handleResend }) => {
  return (
    <div className="w-100 d-flex justify-content-center align-items-center flex-column">
      <p
        style={{
          fontSize: "small",
          opacity: "50%",
          marginBottom: "0rem",
          marginTop: "1rem",
        }}
      >
        Didn't you receive the OTP?
      </p>
      <Button
        type="link"
        style={{
          marginTop: "0rem",
          color: isCountingDown ? "#9CA3AF" : "#605BFF",
        }}
        onClick={handleResend}
        disabled={isCountingDown}
      >
        Resend OTP
        {isCountingDown && <span style={{ color: "#605BFF" }}> ({countdown}s)</span>}
      </Button>
    </div>
  );
};
